import { gql } from '@apollo/client';

export const fetchTransactionAccountForSetInvoiceGroupPane = gql`
  query fetchTransactionAccountForSetInvoiceGroupPane($id: ID!) {
    transactionAccount(id: $id) {
      id
      availableInvoiceGroups {
        nodes {
          id
          name
          currency
          shipToPriceEligibility
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
          }
          defaultPaymentMethod {
            id
            type
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
            ... on PayPal {
              payPal {
                name
                email
              }
            }
          }
        }
      }
    }
  }
`;
